import { useTranslation } from 'react-i18next';
import { TableColumn } from 'react-data-table-component';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';

import { PeriodReportListItem } from 'api/periodReports/type';
import { Breakpoints } from 'hooks/Screen/useScreenSize';
import UserDataCell from 'components/ObjectVuls/UserDataCell';

export const useGetPeriodReportsColumns = (): TableColumn<PeriodReportListItem>[] => {
  let { slug } = useParams();
  const { t } = useTranslation();
  return [
    {
      name: t('PeriodReportList.document'),
      selector: row => row.id,
      cell: row =>
        !row.is_created ? (
          <button className="btn btn-ghost-warning" disabled>
            <i className="ri-loader-2-line ri-spin" /> {t('PeriodReportList.loading')}
          </button>
        ) : (
          <a type="button" className="btn btn-ghost-purple" href={`/r/period-report/${slug}/${row.id}`}>
            <i className="ri-file-paper-line" />
          </a>
        ),
    },
    {
      name: t('PeriodReportList.create_date'),
      selector: row => row.call_date,
      sortable: true,
      sortField: 'call_date',
      cell: row => dayjs(row.call_date).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm'),
      hide: Breakpoints.Tablet,
    },
    {
      name: t('PeriodReportList.created_by'),
      selector: row => row.created_by.name,
      cell: row => <UserDataCell user={row.created_by} />,
      grow: 2,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('PeriodReportList.start_date'),
      selector: row => row.start_date,
      sortable: true,
      sortField: 'start_date',
      cell: row => dayjs(row.start_date).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm'),
    },
    {
      name: t('PeriodReportList.end_date'),
      selector: row => row.end_date,
      sortable: true,
      sortField: 'end_date',
      cell: row => dayjs(row.end_date).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm'),
      hide: Breakpoints.Mobile,
    },
  ];
};
